/**
 * The in-app support form link an API error carries (error.support_url),
 * made safe to navigate to: only the /support page itself, with or without
 * a query, is followed. Anything else (absent, another path, an outside or
 * protocol-relative URL) falls back to plain /support, so a link in an
 * error body can never send the driver off the app.
 *
 * Used by Home Settings for 409 HOME_COUNTRY_LOCKED, and SUPPORT_PATH for
 * the Contact support link under its country lock note.
 */

/** The in-app support form (SupportPage). */
export const SUPPORT_PATH = '/support';

export function supportPathFrom(value: unknown): string {
  if (typeof value !== 'string') return SUPPORT_PATH;
  return value === SUPPORT_PATH || value.startsWith(`${SUPPORT_PATH}?`) ? value : SUPPORT_PATH;
}
